import { useState } from "react";
import { fetchLines, fetchLineDetails } from "../../api/lines";
import { SearchOption } from "../Map/TransitOverlay/MapSearchInput";
import type { LineDetails } from "../../types";

function normalizeQuery(val: string) {
  const m = val.match(/^Linje\s+(\d+)/i);
  return m ? m[1] : val;
}

function formatLineLabel(line: LineDetails) {
  const lineNo = line.LineName || line.id;
  const municipality = (line as any).municipalityName; 

  return municipality
    ? `Linje ${lineNo}, ${municipality}`
    : `Linje ${lineNo}`;
}


export function useLineSearch(
  onAddAndActivateLine: (line: LineDetails) => void
) {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState<SearchOption[]>([]);
  const [loading, setLoading] = useState(false);

  const handleInputChange = async (value: string) => {
    setQuery(value);
    const q = normalizeQuery(value);

    if (q.length < 1) {
      setOptions([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const found = await fetchLines(q);
      
      setOptions(
        found.map((line) => ({
          id: line.id,
          label: formatLineLabel(line),
          value: line.id,
        }))
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = async (option: SearchOption) => {
    if (!option.value) return;

    setLoading(true);
    try {
      const details = await fetchLineDetails(option.value);
      if (details) onAddAndActivateLine(details);
      setQuery("");
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  return { query, options, handleInputChange, handleSelect, loading };
}
export {};
